

//英文版本
export const m = {
  title: '2020 China Yiwu Hardware & Electrical Appliances Trade Fair',
  bigtitle: '2020 China Yiwu Hardware & Electrical Appliances Trade Fair',
  login: 'login',
  verify:'Sliding validation',
  verifystate: 'success',
  drag:'Drag it to the right',
  code:'Get V. code',
  phoneError: 'email error',
  next:'NEXT',
  phone:'Email',
  codefalse:'send failed!',
  foot:'The 2020 China Yiwu Hardware & Electrical Appliances Trade Fair Visitor Registration Deadline is 17:00 of June 12th ,More Details Please Click ',
  upinfo:'Upload ID photos and avatars',
  upportrait:'Upload photo of portrait page',
  upnational:'Upload photos of national emblem page',
  upreal:'Upload your real picture',
  fill:'Question',
  submit:'Submission',
  subheading1:'01 :Which product are you interested in? ',
  subheading2:'02 :Business Type? ',
  subheading3:'03 : The purpose of your visit',
  subheading4:'04 : How did you know this fair',
  subheading5: '05 : Title',
  //subheading1
  s1: '1. Daily Hardware',
  s1_1: '1.1 Stainless Steel Products',
  s1_2: '1.2 Utensils',
  s1_3: '1.3 Kitchenware',
  s1_4: '1.4 Knives & Scissors',
  s2: '2. Hardware Tools',
  s2_1: '2.1 Tool Accessories',
  s2_2: '2.2 Labor Protection Appliance',
  s2_3: '2.3 Auto Maintenance Tools',
  s2_4: '2.4 Garden Tools',
  s2_5: '2.5 Hand Tools/Auto Maintenance Tools',
  s2_6: '2.6 etc',
  s3: '3. Electronic&Electrical Appliance',
  s3_1: '3.1 Lamps & Lighting Decorations',
  s3_2: '3.2 Digital Products',
  s3_3: '3.3 Household Appliance',
  s3_4: '3.4 Instrument & Apparatus',
  s3_5: '3.5 Electrotechnical Products',
  s4: '4. Electromechanical Facilities',
  s4_1: '4.1 Cleaning &Environment-friendly Equipment',
  s4_2: '4.2 Mechanical Equipment',
  s4_3: '4.3 Intelligent Manufacturing Equipment',
  s4_4: '4.4 Mechanical and electronic products',
  s5: '5. Architectural Hardware',
  s5_1: '5.1 Standard Fasteners',
  s5_2: '5.2 Hardware Fitting',
  s5_3: '5.3 Sanitary Wares',
  s5_4: '5.4 Plumbing Equipment',
  s5_5: '5.5 Lock & Padlock',
  ht:'Hardware tools',
  at:'Automotive Tools',
  ah:'Architectural Hardware',
  psw:'Plumbing Sanitary Ware',
  lockset:'Lockset',
  dh:'Daily Hardware',
  eea:'Electronic and Electrical Appliance',
  me:'Mechanical Equipment',
  ef:'Electromechanical Facilities',
  ep:'Environal Products',
  iem:'Intelligent Equipment Manufacturing',
  other:'Others(please list)',
  //subheading2
  manufacturer:'Manufacturer',
  wholesaler : 'Wholesaler',
  agent: 'Agent',
  retailer: 'Retailer',
  ie:'Importer and Exporter',
  ms:'Market/Supermarket',
  nt:'Network Trader',
  ca:'Chamber/Association',
  gm:'Government/Media',
  //subheading3
  buy:'Buy products',
  seek:'Seek cooperation',
  mno:'Make new orders',
  seekagents:'Seek agents',
  gii:'Get information of the industry',
  gintnp:'Get information of new technology and new products',
  fpe:'For the participation of next exhibition',
  //subheading4
  mail:'E-mail ',
  ti:'Telephone Invitation',
  sms:'SMS',
  dm:'Direct Mail',
  oa:'Online Advertisement',
  se:'Search Engine',
  mow:'Mirco Official Website',
  mw:'Micro Wechat',
  outdoor:'Outdoor Advertisement',
  pp: 'Professional Publications',
  oe:'Other Exhibitions',
  rc:'Recommend by Customers',
  ies:'Invited by Exhibitors/Suppliers',
  //subheading5
  ogm:'Owner/General Manager',
  dmpr:'Department Manager/Purchasing Representative',
  br:'Business Representative',

  fillinfo:'Fill in personal information',
  name:'Name(Required)',
  company:'Company',
  ctype:'CredentialType',
  cnumber :'CredentialNumber',
  position :'Position',
  address :'Address',
  mobile :'Mobile',
  email:'Email(Required)',
  emailError: 'email error',
  emailInput: 'email',
  country:'Country(Required)',
  countryError: 'country error',
  nullname:'Please input your name',
  nullcompany:'Please input your english company name',
  nullcnumber:'Please input your Identification Number',
  nullposition:'Please input your post',
  nulladdress:'Please input your address',
  nullmobile:'Please enter the 11-digit mobile phone number correctly',
  secondtitle:'2020 China Yiwu Hardware & Electrical Appliances Trade Fair - Registration Confirmation',
  dear:'Dear ',
  sex:'',
  end:'Thank you for visiting China Yiwu Hardware & Electrical Appliances Trade Fair 2020.',
  ending:'Thank you for visiting China Yiwu Hardware & Electrical Appliances Trade Fair 2020.',
  tips:" Show us the Registration Confirmation ( the QR Code or Bar Code), then get the purchaser's certificate in the self-service machine or the manual window.",
  tips1: 'Under the influence of the COVID-19, 2020 China Yiwu Hardware&Electrical Appliances Trade Fair is postponed to  2021.4.20-4.22, while its online expo activities are to be held on April 20 - June 12. Click',
  tips2: 'Online Hardware Fair',
  tips3: 'to negotiate with exhibitors online directly.',
  tips4: 'Please press the two-dimensional code in the identification chart to return to the applet to participate in the online exhibition.',
  ing:'Appointment in progress…',
  date:'Date：',
  venue:'Venue：',
  place:'Yiwu International Expo Center',
  purchasers:'Purchasers Register office：',
  place1:'1, A1 Hall ,Yiwu International Expo Center .<br>' + '2, The Complex Building, Yiwu International Expo Center.',
  telconsel:'Telephone consultation：',
  modify:'Modify',
  confirm:'confirm number：',
  nameError: 'name error',
  msgTime: 'Go to Online Hardware Fair after 2s',
}
